<!--
 * @Author: FengXiao
 * @Date: 2020-07-27 11:26:17
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-02 21:31:12
-->
<template>
  <div class="episode-list-base">
    <div class="episode-main_title">
      <span v-if="title">{{ title }}</span>
      <span class="total_number">共{{ dataList.length }}集</span>
    </div>
    <div class="episode-swiper-bl">
      <swiper class="swiper" :options="swiperOpt" ref="swiper">
        <swiper-slide v-for="item in dataList" :key="item.id">
          <div class="swiper-page">
            <div class="episode-item" @click="onClickItem(item)">
              <div class="cover-wrap">
                <img :src="item.cover" :alt="item.title" />
                <div class="video_time">{{ item.time }}</div>
              </div>
              <div class="video_intro-wrap">
                <div class="video_title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-btn-wrap">
        <div class="episode swiper-btn-prev swiper-btn">
          <i class="iconfont iconarrow_left"></i>
        </div>
        <div class="episode swiper-btn-next swiper-btn">
          <i class="iconfont iconarrow_right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const EPISODE_PAGE_SIZE = 3.5;
const EPISODE_PAGE_GROUP = 3;
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    datas: {
      type: Array,
      default: () => [],
    },
    initSlide: {
      type: Number,
      default: 0,
    },
  },
  created() {},
  data() {
    return {
      dataList: this.datas,
      swiperOpt: {
        slidesPerView: EPISODE_PAGE_SIZE,
        slidesPerGroup: EPISODE_PAGE_GROUP,
        spaceBetween: 12,
        initialSlide: this.initSlide,
        navigation: {
          prevEl: '.episode.swiper-btn-prev',
          nextEl: '.episode.swiper-btn-next',
        },
      },
    };
  },
  methods: {
    onClickItem(data) {
      this.$emit('select', data);
    },
  },
};
</script>

<style lang="scss" scoped>
.episode-list-base {
  .episode-main_title {
    margin-bottom: 20px;
    margin-top: 30px;
    font-family: HYXinRenWenSongW;
    font-size: 25px;
    color: $C6;
    line-height: 25px;
    .total_number {
      margin-left: 10px;
    }
  }
  .episode-swiper-bl {
    position: relative;
    .swiper {
      padding-bottom: 15px;
      margin-left: auto;
      margin-right: auto;
      .swiper-slide {
        .swiper-page {
          margin: -10px;
          width: calc(100% + 20px);
          height: 100%;
        }
        .episode-item {
          position: relative;
          vertical-align: bottom;
          height: 256px;
          max-height: 256px;
          overflow: hidden;
          margin: 10px;
          background-color: $C9;
          cursor: pointer;
          .cover-wrap {
            height: 160px;
            width: 100%;
            overflow: hidden;
            position: relative;
            & > img {
              width: 100%;
              height: 100%;
              vertical-align: bottom;
              object-fit: cover;
            }
            .video_time {
              color: $C1;
              font-size: 12px;
              background: $A1;
              width: 56px;
              height: 25px;
              text-align: center;
              line-height: 25px;
              position: absolute;
              bottom: 10px;
              right: 10px;
              font-weight: 100;
            }
          }
          .video_intro-wrap {
            width: 100%;
            height: 96px;
            background-color: $C1;
            padding: 20px;
            box-sizing: border-box;
            overflow: hidden;
            .video_title {
              color: $C6;
              font-size: 16px;
              line-height: 17px;
              font-family: HYXinRenWenSongW;
            }
          }
        }
        .episode-item {
          transition: box-shadow 0.3s ease;
          .video_intro-wrap {
            .video_title {
              min-height: 40px;
            }
          }
          &:hover {
            box-shadow: 3px 3px 6px $A5;
          }
        }
      }
    }
  }
}
</style>
